import React from 'react';

import { strings } from 'constants/index';
import { ErrorPage } from 'pages/common/errors';

const ServerError: React.FC = () => {
  return (
    <ErrorPage message={strings.Site.ErrorOccurred}>
      5<i className="bx bx-buoy bx-spin text-primary display-3" />0
    </ErrorPage>
  );
};

export default ServerError;
